import { useCallback } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useIsCommentEscScopeActive } from '@scene'
import { useSelectionStore } from '@editorStores'

/**
 * Escape deselects the selected table / comment / image card, closing its form in the drawer.
 * While the comment tooling owns Escape (its own scope: callout drawing, a selected comment) it
 * handles the key itself, so this stays out of the way.
 */
const usePlanViewEsc = (): void => {
  const hasPlanSelection = useSelectionStore(state => !!state.planSelection)
  const selectPlanElement = useSelectionStore(state => state.selectPlanElement)
  const isCommentEscScopeActive = useIsCommentEscScopeActive()

  const onEsc = useCallback(() => selectPlanElement(null), [selectPlanElement])

  useHotkeys('esc', onEsc, { enabled: hasPlanSelection && !isCommentEscScopeActive }, [onEsc])
}

export default usePlanViewEsc
